import PropTypes from "prop-types";
import ProductDeal from "./ProductDeal";
import ProductSponsored from "./ProductSponsored";
import SellingFastBadge from "./SellingFastBadge";
import styles from "./index.css";
import classnames from "classnames";

const Banners = ({ deal, isSponsored, isSellingFast, sellingFastStyle }) => (
  <>
    {deal !== null && (
      <ProductDeal deal={deal} className={styles.topLeftBadge} />
    )}
    {isSponsored && <ProductSponsored className={styles.topRightBadge} />}
    {isSellingFast && (
      <SellingFastBadge
        className={classnames(styles.sellingFastBadge, sellingFastStyle)}
      />
    )}
  </>
);

Banners.propTypes = {
  deal: PropTypes.string,
  isSponsored: PropTypes.bool.isRequired,
  isSellingFast: PropTypes.bool.isRequired,
  sellingFastStyle: PropTypes.string
};

export default Banners;
